/* eslint-disable import/no-unresolved */
import React from 'react';

import knowledgeableSVG from 'assets/resources/icon/knowledgeable.svg';
import hassleSVG from 'assets/resources/icon/hassle-free.svg';
import ondemandSVG from 'assets/resources/icon/ondemand team.svg';
import ImgHTML from '../../ImgHTML';

const iconsSection = () => {
  return (
    <div className="icon-beam">
      <div className="subtitle-simple">You get from us</div>
      <div className="row">
        <div className="col-md-4">
          <div className="single-item">
            <div className="icon">
              <ImgHTML
                src={knowledgeableSVG}
                alt="knowledgeable"
                title="knowledgeable"
              />
            </div>
            <div className="content">
              <div className="tt">
                Knowledgeable team and CTO expertise on demand
              </div>
              <div className="dd">
                <p>
                  Our team understands the business. We speak business and IT .
                  We will suggest the right technology stack. If you need a CTO,
                  then one of our team leaders can support your team as an
                  Interim CTO.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="single-item">
            <div className="icon">
              <ImgHTML src={hassleSVG} alt="hassle" title="hassle" />
            </div>
            <div className="content">
              <div className="tt">Hassle-free recruitment</div>
              <div className="dd">
                <p>
                  Free yourself from the burden of recruitment processes and
                  costs. Outsourcing IT is recommended for dynamic teams that
                  compete in the technological market.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="single-item">
            <div className="icon">
              <ImgHTML src={ondemandSVG} alt="ondemand" title="ondemand" />
            </div>
            <div className="content">
              <div className="tt">On-demand team</div>
              <div className="dd">
                <p>
                  Cooperating with Ulam Labs you can fast scale up and down your
                  tech team. No need to worry about how to get additional
                  resources when required or employing a developer who is only
                  partially engaged with your project.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default iconsSection;
